import { IconButton, PropTypes } from '@material-ui/core'
import FormControl from '@material-ui/core/FormControl'
import FormHelperText from '@material-ui/core/FormHelperText'
import VisibilityIcon from '@material-ui/icons/Visibility'
import VisibilityOffIcon from '@material-ui/icons/VisibilityOff'
import React from 'react'
import { Field } from 'react-final-form'

interface Props {
    name: string
    margin?: PropTypes.Margin
    onChange?: (value: string) => void
}

const HiddenField: React.FC<Props> = ({ name, margin = 'normal', onChange: onExternalChange }) => {
    return (
        <Field name={name}>
            {({ input: { onChange, value }, meta }) => {
                const hasError =
                    ((meta.submitError && !meta.dirtySinceLastSubmit) || meta.error) && meta.touched
                const handleChangeValue = () => {
                    onChange(!value)
                }
                return (
                    <FormControl fullWidth margin={margin} error={hasError}>
                        <IconButton onClick={handleChangeValue}>
                            {value ? <VisibilityOffIcon /> : <VisibilityIcon />}
                        </IconButton>
                        {meta.error && meta.touched && (
                            <FormHelperText error={hasError}>{meta.error}</FormHelperText>
                        )}
                    </FormControl>
                )
            }}
        </Field>
    )
}

export default HiddenField
